import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceListItemComponent } from './marketplace-list-item.component';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CarouselModule } from 'ngx-owl-carousel-o';

@NgModule({
  declarations: [MarketplaceListItemComponent],
  imports: [
    CommonModule,
    LoyaltyIconModule,
    PipesModule,
    DirectivesModule,
    RouterModule,
    CarouselModule,
    FGBSharedModule
  ],
  exports: [MarketplaceListItemComponent],
})
export class MarketplaceListItemModule {}
